// extracted by css-extract-rspack-plugin
export default {"selectUserPage":"src-modules-auth-pages-SelectUserPage-SelectUserPage-module__selectUserPage-kMlls6","users":"src-modules-auth-pages-SelectUserPage-SelectUserPage-module__users-a7nFYh","userWrapper":"src-modules-auth-pages-SelectUserPage-SelectUserPage-module__userWrapper-FonI1a"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"selectUserPage\":\"src-modules-auth-pages-SelectUserPage-SelectUserPage-module__selectUserPage-kMlls6\",\"users\":\"src-modules-auth-pages-SelectUserPage-SelectUserPage-module__users-a7nFYh\",\"userWrapper\":\"src-modules-auth-pages-SelectUserPage-SelectUserPage-module__userWrapper-FonI1a\"}";
        // 1793873546947
        var cssReload = require("../../../../../node_modules/.pnpm/@rspack+core@1.5.8_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  